<template>
	<div class="col" gutter="20">
		<Title title="公佈欄管理" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="輸入標題" />

		<div class="row" align-x="between">
			<el-button @click="openDialog()" type="primary" icon="el-icon-plus" size="mini">上傳</el-button>
			<el-pagination v-if="posts.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="posts.total" />
		</div>

		<el-table :data="posts.list">
			<el-table-column label="日期">
				<template slot-scope="{row}">
					{{transformTimestamp(row.date)}}
				</template>
			</el-table-column>
			<el-table-column label="標題" prop="title" />
			<el-table-column label="狀態">
				<template slot-scope="{row}">
					<el-tag :type="row.is_published ? 'success' : 'info'">
						{{row.is_published ? "發布" : "草稿"}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{row}">
					<el-button @click="openDialog(row)" type="text">編輯</el-button>
					<el-button @click="handleDatete(row.id)" icon="el-icon-delete" type="text" class="color-danger"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="上傳公佈欄" :visible="dialogVisible" v-loading.fullscreen.lock="loading" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog()">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="80px">
				<el-form-item label="日期" prop="date">
					<el-date-picker v-model="ruleForm.date" type="date" value-format="timestamp" placeholder="選擇日期" />
				</el-form-item>
				<el-form-item label="標題" prop="title">
					<el-input v-model="ruleForm.title" placeholder="輸入標題"></el-input>
				</el-form-item>
				<el-form-item label="內文" prop="content">
					<el-input v-model="ruleForm.content" placeholder="填寫內容" type="textarea" :autosize="{minRows:3}"></el-input>
				</el-form-item>
				<el-form-item label="照片" prop="pictures">
					<el-upload :action="postURL" :limit="1" :file-list="ruleForm.pictures" :on-success="handleUploadSuccess" :on-remove="handleRemove" :before-upload="handleUpload" :on-preview="handlePreview">
						<el-button v-if="ruleForm.pictures.length < 1" type="primary" icon="el-icon-plus" size="mini">上傳</el-button>
						<p slot="tip"><small>只能上傳圖片，且不超過5MB</small></p>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<div class="row" align-x="right">
						<el-button type="info" @click="handleSubmit(false)">暫存為草稿</el-button>
						<el-button type="success" @click="handleSubmit(true)">發布</el-button>
					</div>
				</el-form-item>
			</el-form>
			<el-dialog :visible.sync="innerDialogVisible" append-to-body>
				<img :src="previewURL" alt="" width="100%" />
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import API from "@/api";
import _ from "lodash";
import moment from "moment-timezone";

function fields() {
	return {
		date: '',
		title: '',
		content: '',
		pictures: []
	}
}

export default {
	components: { Title, SearchBar },
	data() {
		return {
			isNewPost: true,
			loading: false,
			dialogVisible: false,
			innerDialogVisible: false,
			previewURL: '',
			currentPage: 1,
			pageSize: 10,
			searchText: "",
			publishStatus: undefined,
			newsList: [],
			ruleForm: fields(),
			rules: {
				date: [{ required: true, message: '選擇日期', trigger: 'blur' }],
				title: [{ required: true, message: '輸入標題', trigger: 'blur' }],
				content: [{ required: true, message: '填寫內文', trigger: 'blur' }],
				pictures: [{ required: true, message: '上傳照片', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapState('billboard', ['posts']),
		postURL() {
			return `${API.baseURL}/api/upload/image/billboard`;
		},
		query: {
			get() {
				return {
					page: this.currentPage,
					size: this.pageSize,
					text: this.searchText,
					published: this.publishStatus
				}
			},
			set({ page, size, text, published }) {
				if (page) this.currentPage = Number(page);
				if (size) this.pageSize = Number(size);
				if (text) this.searchText = text;
				if (published) this.publishStatus = JSON.parse(published);
			}
		}
	},
	watch: {
		async $route(val) {
			await this.getPosts(this.query);
		}
	},
	methods: {
		...mapActions('billboard', ['createPost', 'updatePost', 'getPosts', 'deletePost']),
		init() {
			if (this.$route.query) this.query = this.$route.query;
		},
		handleSearch(text) {
			this.searchText = text;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleCurrentChange(page) {
			this.currentPage = page;
			this.$router.replace({ query: this.query });
		},
		resetForm() {
			this.$refs['ruleForm'].clearValidate();
			this.ruleForm = fields();
		},
		openDialog(data) {
			if (data) this.ruleForm = data;
			this.isNewPost = data ? false : true;
			this.dialogVisible = true;
		},
		closeDialog() {
			this.resetForm();
			this.dialogVisible = false;
		},
		handleUpload(event, file, fileList) {
			this.loading = true;
		},
		handleUploadSuccess(response, file, fileList) {
			this.loading = false;
			this.ruleForm.pictures.push({ name: file.name, url: response.Location });
		},
		handleRemove(file, fileList) {
			this.ruleForm.pictures = fileList.map(file => new Object({
				name: file.name,
				url: file.url
			}));
		},
		handleSubmit(is_published) {
			this.$refs['ruleForm'].validate(async valid => {
				if (valid) {
					_.assign(this.ruleForm, { is_published });
					try {
						if (this.isNewPost) {
							await this.createPost({ query: this.query, data: this.ruleForm });
						} else {
							await this.updatePost({ query: this.query, data: this.ruleForm });
						}
						this.closeDialog();
					} catch (e) {
						this.$message.error(e);
					}
				}
			})
		},
		handleDatete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '確定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deletePost({ query: this.query, id });
				this.$message({
					type: 'success',
					message: '刪除成功！'
				});
			}).catch(() => { });
		},
		handlePreview(file) {
			this.previewURL = file.url;
			this.innerDialogVisible = true;
		},
		transformTimestamp(timestamp) {
			return moment(timestamp).tz('Asia/Taipei').format('YYYY-MM-DD');
		}
	},
	async created() {
		this.init();
		await this.getPosts(this.query);
	}
};
</script>

<style lang="scss" scoped>
</style>